import React, { useEffect } from 'react';
import { CheckCircle2, AlertCircle, Info, X } from 'lucide-react';
import './ModernAdmissionsToast.css';

/**
 * ModernAdmissionsToast Component
 * Floating high-visibility notification card designed for executive/admin actions.
 * Appears prominently in the top-right viewport with glassmorphism, progress countdown bar,
 * and high contrast so users never miss a notification regardless of scroll position.
 */
export default function ModernAdmissionsToast({ toast, onClose, duration = 15000 }) {
  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => {
      onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [toast, onClose, duration]);

  if (!toast) return null;

  const isSuccess = toast.type === 'success';
  const isError = toast.type === 'error';
  const isWarning = toast.type === 'warning' || toast.type === 'info';

  const defaultTitle = isSuccess
    ? 'Aksi Berhasil Diproses'
    : isError
    ? 'Terjadi Kendala / Penolakan'
    : 'Pemberitahuan Sistem';

  return (
    <div className="mat-floating-portal">
      <div className={`mat-toast-card mat-${toast.type || 'info'}`} role="alert">
        <div className="mat-toast-body">
          <div className="mat-icon-wrapper">
            {isSuccess && <CheckCircle2 size={20} className="mat-icon-svg" />}
            {isError && <AlertCircle size={20} className="mat-icon-svg" />}
            {isWarning && <Info size={20} className="mat-icon-svg" />}
          </div>

          <div className="mat-content">
            <h4 className="mat-title">{toast.title || defaultTitle}</h4>
            <p className="mat-message">{toast.text || toast.message}</p>
          </div>

          <button
            type="button"
            className="mat-close-btn"
            onClick={onClose}
            aria-label="Tutup Notifikasi"
          >
            <X size={16} />
          </button>
        </div>

        {/* Animated Countdown Progress Bar */}
        <div
          className="mat-progress-bar"
          style={{ animationDuration: `${duration}ms` }}
        />
      </div>
    </div>
  );
}
